import {Model} from 'vue-mc'

export default class Album extends Model {
  defaults() {
    return {
      id: null,
      name: null,
      status: 'draft',
      photos: [],
    }
  }

  canSend() {
    return this.status != 'draft';
  }
}
